module.exports = __webpack_public_path__ + "img/ocean_big.afb9610e.png";